module.exports = __webpack_public_path__ + "static/media/lead-form-finish.01740f28.jpg";